import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoToggle from '../../components/toggle/pendo-toggle.vue.js';
import PendoDivider from '../../components/divider/pendo-divider.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoMultiselect from '../../components/multiselect/pendo-multiselect.vue.js';
import PendoIconOption from '../../components/multiselect/option-types/pendo-icon-option.vue.js';
import LocalizationModal from './localization-modal.vue.js';
import get from 'lodash/get.js';
import isUndefined from 'lodash/isUndefined.js';
import isEmpty from 'lodash/isEmpty.js';
import { MODAL_TYPES } from './localization-modal.vue2.js';

const CONFIRMATION_MODAL_SETTINGS = {
  disableFallback: 'disableFallback',
  disableLocalization: 'disableLocalization'
};
var script = {
  name: 'PendoLocalizationSettingsPage',
  components: {
    PendoButton,
    PendoIcon,
    PendoModal,
    PendoDivider,
    PendoTable,
    PendoCard,
    PendoToggle,
    PendoMultiselect,
    PendoIconOption,
    LocalizationModal
  },
  directives: {
    PendoTooltip
  },
  props: {
    app: {
      type: Object,
      required: true
    },
    disableChangeFallbackStrategy: {
      type: Boolean,
      default: false
    },
    disableDeleteSupportedLanguages: {
      type: Boolean,
      default: false
    },
    disableLocalizationConfirmationMessage: {
      type: [String, Boolean],
      default: null
    },
    languageMapping: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Array,
      default: () => []
    },
    configLoading: {
      type: Boolean,
      default: true
    },
    languageTableData: {
      type: Array,
      default: () => []
    },
    localizationConfig: {
      type: Object,
      default: () => {}
    },
    serverErrorMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      columns: [{
        prop: 'name',
        label: 'Language'
      }, {
        prop: 'metadataValue',
        label: 'Metadata Value'
      }, {
        type: 'actions',
        width: 80
      }],
      showLangModal: false,
      selectedLanguage: {},
      modalType: '',
      confirmationModalSetting: null,
      fallbackStrategy: {
        useDefaultLanguage: 'useDefaultLanguage',
        doNotDisplay: 'doNotDisplay'
      },
      MODAL_TYPES
    };
  },
  computed: {
    appId() {
      return get(this.app, 'id', null);
    },
    isLocalizationEnabled() {
      return get(this.app, 'applicationFlags.guideLocalization', false);
    },
    confirmationModalConfig() {
      return {
        [CONFIRMATION_MODAL_SETTINGS.disableLocalization]: {
          title: 'Disable Localization?',
          message: this.disableLocalizationConfirmationMessage,
          action: () => {
            this.toggleLocalization(false);
          }
        },
        [CONFIRMATION_MODAL_SETTINGS.disableFallback]: {
          title: 'Disable Setting?',
          message: 'Any public guides or resource centers with missing translations will not appear for users.',
          action: () => {
            this.$emit('update-app-localization-property', {
              prop: 'fallbackStrategy',
              value: this.fallbackStrategy.doNotDisplay
            });
          }
        }
      };
    },
    confirmationModal() {
      return this.confirmationModalConfig[this.confirmationModalSetting] || {};
    },
    deleteTooltipConfig() {
      return {
        arrow: true,
        multiline: true,
        trigger: 'hover',
        content: this.disableDeleteSupportedLanguages ? 'Cannot delete this Supported Language as it will impact the delivery of your translated guides' : 'Delete',
        delay: {
          show: 300,
          hide: 0
        }
      };
    },
    loading() {
      return this.configLoading || isEmpty(this.options);
    },
    selectedOption() {
      const {
        languageMetadataFieldName
      } = this.localizationConfig;
      if (!languageMetadataFieldName) {
        return;
      }
      return this.options.find(option => {
        return option.id === languageMetadataFieldName;
      });
    }
  },
  methods: {
    toggleLocalization(guideLocalization) {
      if (!guideLocalization && this.disableLocalizationConfirmationMessage && !this.confirmationModalSetting) {
        this.confirmationModalSetting = CONFIRMATION_MODAL_SETTINGS.disableLocalization;
        return;
      }
      const applicationFlags = _objectSpread2(_objectSpread2({}, this.app.applicationFlags), {}, {
        guideLocalization
      });
      this.$emit('update-app-localization', {
        app: this.app,
        updates: {
          applicationFlags
        }
      });
    },
    openLangModal(row, type) {
      this.selectedLanguage = row;
      this.modalType = type;
      this.showLangModal = true;
    },
    updateLanguagePreference(languageMetadataFieldName) {
      this.$emit('update-app-localization-property', {
        prop: 'languageMetadataFieldName',
        value: languageMetadataFieldName.id
      });
      this.handleLanguageModalClose();
    },
    updateLanguage(_ref) {
      let {
        appId,
        code,
        metadataValue
      } = _ref;
      this.$emit('update-language', {
        appId,
        code,
        metadataValue
      });
    },
    handleLanguageModalClose() {
      this.showLangModal = false;
      setTimeout(() => {
        this.modalType = '';
        this.selectedLanguage = {};
      }, 200);
    },
    onConfirmationModalConfirm() {
      this.confirmationModal.action();
      this.confirmationModalSetting = null;
    },
    onToggleFallbackStrategy() {
      if (this.localizationConfig.fallbackStrategy === this.fallbackStrategy.useDefaultLanguage) {
        this.confirmationModalSetting = CONFIRMATION_MODAL_SETTINGS.disableFallback;
      } else if (this.localizationConfig.fallbackStrategy === this.fallbackStrategy.doNotDisplay) {
        this.$emit('update-app-localization-property', {
          prop: 'fallbackStrategy',
          value: this.fallbackStrategy.useDefaultLanguage
        });
      }
    },
    isRowValid(row) {
      return !isUndefined(row.name) && !isUndefined(row.nativeName) && !row.isDeprecated;
    },
    deleteLanguageFromApp(_ref2) {
      let {
        appId,
        langCode
      } = _ref2;
      this.$emit('delete-language', {
        appId,
        langCode
      });
      this.handleLanguageModalClose();
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-localization-settings-page.vue2.js.map
